import React from "react";
import styles from "./IR330C.module.scss";

const IR330CPrivacyNote = () => {
  return (
    <div className={styles.privacyNote}>
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <p className="mb-1 title" style={{ fontSize: "20px" }}>
            <strong>Privacy</strong>
          </p>
          <p>
          Meeting your tax obligations means giving us accurate information so we can assess your liabilities or your entitlements under the Acts we
administer. We may charge penalties if you do not.<br />
            We may also exchange information about you with:
          </p>
          <ul>
            <li className="pl-2">some government agencies </li>
            <li className="pl-2">another country, if we have an information supply agreement with them</li>
            <li className="pl-2">Statistics New Zealand (for statistical purposes only).</li>
          </ul>

          <p>
          You can ask to see the personal information we hold about you and correct any errors, unless we have a lawful reason not to.
          Contact us on 0800 377 774 for more information. For full details of our privacy policy go to{" "}
            <a href="https://www.ird.govt.nz/privacy" target="_blank" rel="noreferrer">
              <strong> ird.govt.nz/privacy</strong>
            </a>
          </p>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-9" />
      </div>
      <div />
    </div>
  );
};

export default IR330CPrivacyNote;
